<template>
    <VeeForm v-slot="{ handleSubmit, validate: formValidate, errors }" ref="observer" as="div">
        <form v-bind="$attrs" @submit.prevent="handleSubmit($event, onSubmit)">
            <slot></slot>
        </form>
    </VeeForm>
</template>

<script>
import { Form as VeeForm } from 'vee-validate';

export default {
    inheritAttrs: false,
    name: 'p-form',
    emits: ['submit'],
    components: { VeeForm },
    methods: {
        async validate() {
            const result = await this.$refs.observer.validate();
            return result.valid;
        },
        reset() {
            // Soft reset: clear validation errors only, keep field values intact.
            // vee-validate 4's resetForm() also wipes values back to their initial
            // state, which would blank user-entered fields — not the legacy behavior.
            this.$refs.observer?.setErrors?.({});
        },
        onSubmit() {
            this.$emit('submit');
        },
        isFieldInvalid(fieldName){
           const errors = this.$refs.observer.getErrors();
           return errors[fieldName] ? errors[fieldName].length > 0 : null;
        },
    }
};
</script>
